import { render, staticRenderFns } from "./ErrorModalCard.vue?vue&type=template&id=1a0d6110&scoped=true&"
import script from "./ErrorModalCard.vue?vue&type=script&lang=js&"
export * from "./ErrorModalCard.vue?vue&type=script&lang=js&"
import style0 from "./ErrorModalCard.vue?vue&type=style&index=0&id=1a0d6110&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0d6110",
  null
  
)

export default component.exports